import { Pipe, PipeTransform } from '@angular/core';

/**
 * Sanitization pipe that cleans input values for safe display.
 * Self-contained: inlines the sanitization logic so there is no
 * dependency on the app-level SanitizationService.
 */
@Pipe({
  name: 'sanitize',
  standalone: true
})
export class SanitizePipe implements PipeTransform {

  transform(value: string, type: 'html' | 'text' | 'url' = 'text'): string {
    if (!value) return '';

    switch (type) {
      case 'html':
        return this.sanitizeHtml(value);
      case 'url':
        return this.sanitizeUrl(value);
      case 'text':
      default:
        return this.sanitizeText(value);
    }
  }

  private sanitizeHtml(html: string): string {
    if (!html) return '';
    const div = document.createElement('div');
    div.textContent = html;
    return div.innerHTML;
  }

  private sanitizeUrl(url: string): string {
    if (!url) return '';
    const safeProtocols = ['http:', 'https:', 'mailto:', 'tel:'];
    try {
      const urlObj = new URL(url);
      if (safeProtocols.includes(urlObj.protocol)) {
        return url;
      }
    } catch {
      // Invalid URL
    }
    return '';
  }

  private sanitizeText(text: string): string {
    if (!text) return '';
    return text
      .replace(/<[^>]*>/g, '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#x27;')
      .replace(/\//g, '&#x2F;');
  }
}
